import React from 'react';

function getProductImage(financialOrSigla?: any, productOrSigla?: any): React.ImgHTMLAttributes<HTMLImageElement> {
    // financialOrSigla may be a string (sigla) or object with .sigla
    // productOrSigla may be the same for product
    const financialSigla = typeof financialOrSigla === 'string' ? financialOrSigla : financialOrSigla?.sigla || financialOrSigla?.sigla;
    const productSigla = typeof productOrSigla === 'string' ? productOrSigla : productOrSigla?.sigla;

    const sigla = financialSigla || productSigla || 'default';
    const base = (typeof process !== 'undefined' && process.env && process.env.PUBLIC_URL) ? process.env.PUBLIC_URL : '';
    // ensure no double slashes
    const prefix = base ? base.replace(/\/$/, '') : '';
    return {
        src: `${prefix}/assets/img/products/${sigla}.png`,
        alt: sigla === 'default' ? '' : sigla
    };
}

export {getProductImage};
export default getProductImage;

